import { AppStatus, RequestState } from '@models/Common'
import { Action } from '@utils/reducers/Action'
import { MovieEntry, topMovieGenres } from '@models/Movie'
import environment from 'config/environment'

export type MovieState = RequestState & {
  movie: string
  movies: MovieEntry[]
  selectedMovie?: MovieEntry
  genres: string[]
  selectedGenre?: string
}

export const initialState: MovieState = {
  status: AppStatus.IDLE,
  errorMessage: undefined,
  movie: '',
  movies: [],
  selectedMovie: undefined,
  genres: topMovieGenres.map((g) => g.name),
  selectedGenre: undefined,
}

export enum MovieActionType {
  SearchMoviesPending,
  SearchMoviesSuccess,
  SearchMoviesFailure,
  SelectMovie,
  SelectGenre,
}

const MovieReducer = (
  state: MovieState,
  action: Action<MovieActionType, string | MovieEntry[] | MovieEntry | undefined>,
): MovieState => {
  if (environment.isDev) {
    // eslint-disable-next-line no-console
    console.log({ reducer: 'movie', state, action })
  }

  switch (action.type) {
    case MovieActionType.SearchMoviesPending:
      return { ...state, status: AppStatus.PENDING, movie: action.payload as string }
    case MovieActionType.SearchMoviesFailure:
      return { ...state, status: AppStatus.ERROR, movies: [], errorMessage: action.payload as undefined }
    case MovieActionType.SearchMoviesSuccess:
      return { ...state, status: AppStatus.IDLE, errorMessage: undefined, movies: action.payload as MovieEntry[] }
    case MovieActionType.SelectMovie:
      return {
        ...state,
        selectedMovie: action.payload as MovieEntry,
        movie: (action.payload as MovieEntry)?.title,
        selectedGenre: (action.payload as MovieEntry)?.genre,
      }
    case MovieActionType.SelectGenre:
      return { ...state, selectedGenre: action.payload as string }

    default:
      return state
  }
}

export default MovieReducer
